import { gql } from '@apollo/client'

export const LOGOUT = gql`
  mutation Logout($input: LogoutInput!, $action: ActionInput!) {
    logout(input: $input, action: $action)
  }
`
